import React, { useCallback } from 'react';
import { TextField } from '@mui/material';

const RegexTextField = ({ regex, onChange, ...rest }: any) => {
  const handleChange = useCallback(
    (e: any) => {
      e.currentTarget.value = e.currentTarget.value.replace(regex, '');
      onChange(e);
    },
    [onChange, regex]
  );

  return <TextField onChange={handleChange} {...rest} variant="standard" />;
};

export default React.memo(RegexTextField);
